import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'textarea',
  standalone: true,
})
export class EnterNewlineTextareaDirective {
  constructor() {}

  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    const target = event.target as HTMLTextAreaElement;

    if (!target) {
      return;
    }

    if (event.key === 'Enter') {
      // Check if the Enter key is pressed without modifier keys (e.g., Shift, Ctrl)
      if (
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.altKey &&
        !event.metaKey
      ) {
        // Insert a newline character at the cursor's current position
        const start = target.selectionStart;
        const end = target.selectionEnd;
        const value = target.value;

        target.value = value.substring(0, start) + '\n' + value.substring(end);
        target.selectionStart = target.selectionEnd = start + 1;

        // Prevent the default behavior to avoid any unintended side effects
        event.preventDefault();
      }
      // If Enter is pressed with modifier keys, allow default behavior (e.g., Shift+Enter for newline)
    }
  }
}
